import React from "react";

export const XClose = (props) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none" {...props}>
            <path d="M1 1L16 16" stroke="#05272D" strokeWidth="2" strokeMiterlimit="10"/>
            <path d="M16 1L1 16" stroke="#05272D" strokeWidth="2" strokeMiterlimit="10"/>
        </svg>
    )
}
